<div class="pr">
  <div class="callToAction" style="height: 35px;"
       [class]="{'noActionRequired': (state.isPending || state.isNA) && !state.actionRequired,
       'approved': state.isApproved, 'refused': state.isRefused, 'ignored': state.isIgnored}">
    <div class="left actionSection">
      @if (state.isPending || state.isNA) {
        <div>
          <div style="display:inline-block;margin-right:10px;">
            <img class="pr-critical-default" src="assets/images/critical_default.png"/>
            <i class="pi pi-exclamation-triangle"></i>
            @if (state.actionRequired) {
              <span class="actionItem" data-action-required>ACTION REQUIRED</span>
            }
            @if (!state.actionRequired) {
              <span class="actionItem" data-no-action-required>NO ACTION REQUIRED</span>
            }
            @if (state.ordersProposed && !state.userChangedOrders) {
              <span>&nbsp;|&nbsp;
                <span class="actionDetail" data-potential-orders>Please review potential orders.
                  <!--<a *ngIf="!isModified" (click)="viewAuditTrail()" data-audit-link>View changes</a>-->
                </span></span>
              }
              @if (state.ordersProposed && state.userChangedOrders) {
                <span>&nbsp;|&nbsp;<span class="actionDetail"
                  data-user-changed-orders>Orders have been changed by the user. @if (!isModified) {
                  <a
                  (click)="viewAuditTrail()" data-audit-link>View changes</a>
                }</span></span>
              }
              @if (!state.ordersProposed && !state.userChangedOrders) {
                <span>&nbsp;|&nbsp;<span class="actionDetail" data-no-proposed-orders>No orders proposed by iRebal.</span></span>
              }
              @if (!state.ordersProposed && state.userChangedOrders) {
                <span>&nbsp;|&nbsp;<span class="actionDetail"
                  data-user-created-orders>No orders proposed by iRebal, but the user created orders. @if (!isModified) {
                  <a
                  (click)="viewAuditTrail()" data-audit-link>View Audit Trail</a>
                }</span></span>
              }
              @if (state.ordersProposed && state.userRemovedOrders) {
                <span>&nbsp;|&nbsp;<span class="actionDetail" data-user-removed-orders>iRebal proposed orders, but user removed them.</span></span>
              }
            </div>
            @if (state.reEnabledOrRecalled) {
              <div style="display:inline-block;">
                <span class="actionItem" data-enabled-or-recalled-action>{{state.actionTaken}}</span>&nbsp;|&nbsp;
                <span class="actionDate" data-enabled-or-recalled-date>{{data.modifiedOn | date: 'E MM/dd/yyyy hh:mm:ss a'}}{{data.modifiedOn ? ' ET' : ''}}</span>&nbsp;|&nbsp;
                <span class="actionAuthor" data-enabled-or-recalled-author>{{data.modifiedBy}}</span>
              </div>
            }
          </div>
        }
        @if (state.isApproved) {
          <div>
            <div style="display:inline-block; margin-right:10px;">
              <img class="pr-checkmark-circle" src="assets/images/checkmark-circle.png"/>
              <span class="actionItem approved" data-approved-action>APPROVED</span>&nbsp;|&nbsp;
              <span class="actionDate" data-approved-date>{{data.modifiedOn | date: 'E MM/dd/yyyy hh:mm:ss a'}}{{data.modifiedOn ? ' ET' : ''}}</span>&nbsp;|&nbsp;
              <span class="actionAuthor" data-approved-author>{{data.modifiedBy}}</span>
            </div>
            @if (data.userEdit) {
              <div class="actionMisc" data-user-changed-approved-orders
                style="display:inline-block;margin-right:10px;">Approved orders have been
                user-edited. @if (!isModified) {
                <a (click)="viewAuditTrail()" data-audit-link>View audit trail</a>
              }</div>
            }
            @if (isTrader) {
              <div class="actionMisc" style="display:inline-block;">
                <a (click)="viewOrdersOnBlotter()"  data-view-order-blotter>View these orders</a> on the
                order blotter.
              </div>
            }
          </div>
        }
        @if (state.isRefused) {
          <div>
            <div>
              <img class="pr-critical-default" src="assets/images/critical_default.png"/>
              <span class="actionItem" data-refused-action>REFUSED</span>&nbsp;|&nbsp;
              <span class="actionDate" data-refused-date>{{data.modifiedOn | date: 'E MM/dd/yyyy hh:mm:ss a'}}{{data.modifiedOn ? ' ET' : ''}}</span>&nbsp;|&nbsp;
              @if (!data.refusedGainsThreshold) {
              <span class="actionAuthor" data-refused-author>{{data.modifiedBy}}</span>
              } @else {
                <span class="actionAuthor" data-refused-author>The result was refused for this portfolio because it exceeded gain threshold</span>
              }
              <span class="actionDetail">@if (data.userEdit) {
                <a (click)="viewAuditTrail()" data-audit-link>&nbsp; View changes</a>
              }</span>
            </div>
          </div>
        }
        @if (state.isIgnored) {
          <div>
            <div>
              <i class="pi pi-exclamation-triangle"></i>
              <span class="actionItem" data-ignored-action>IGNORED</span>&nbsp;|&nbsp;
              <span
                class="actionMisc" data-view-newer-result>View newer, pending result for this portfolio from <a>{{data.latestRebalanceName}}</a></span>
              </div>
            </div>
          }
        </div>
        <div class="right">
          @if (state.isUnresolved) {
            <div data-unresolved style="display:inline-block; margin-right:10px;">
              This rebalance was unresolved. You can view the reason in the <b>Explanation</b> above.
            </div>
          }
          @if (state.isUnresolved && !state.isManualAdjust) {
            <div data-manual-adjustment style="display:inline-block;">If
              you want to manually enter orders for this portfolio,
              <a (click)="runManualAdjustmentDialog($event)">run a manual adjustment.</a></div>
            }
          </div>
        </div>
        <div class="clear" style="height:1px;"></div>
      </div>
      <irb-common-dialog #dialog></irb-common-dialog>
